import { render, staticRenderFns } from "./KeywordStats.vue?vue&type=template&id=4755659a&scoped=true&"
import script from "./KeywordStats.vue?vue&type=script&lang=js&"
export * from "./KeywordStats.vue?vue&type=script&lang=js&"
import style0 from "./KeywordStats.vue?vue&type=style&index=0&id=4755659a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755659a",
  null
  
)

export default component.exports